import React from 'react';
// async/await will function only after babel-polyfill has been loaded
import 'babel-polyfill';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';
import L from 'react-loadable';

import NotFoundPage from './containers/NotFoundPage';
import AuthManager from './services/AuthManager';
import PrivateRoute from './components/BaseComponents/PrivateRoute';
import AppLoader from './components/BaseComponents/AppLoader';
import FaqsPage from './components/FaqsPage';
import FaqsPageHashLink from './components/FaqsPageHashLink';

/**
 * lazy loading using webpack code splitting
 * AppLoader will be used as loader if module takes
 * longer than the mentioned delay
 * @param  {[type]} opts options for react loadable
 * @return {function}  Component
 */
const loadable = (opts) => L({
  loading: AppLoader,
  delay: 300, // 0.3 seconds
  ...opts
}),

  /*
   * webpack Dynamic loading for auth
   * So there will be 3 chunks for the webapp
   * First for the authentication which will kick
   * in only if user is unauthenticated
   * Second for the dashboard app and third for onboarding
   */
  AsyncAuthApp = loadable({
    loader: () => import('./containers/AuthApp')
  }),
  AsyncDashboardApp = loadable({
    loader: () => import('./containers/App')
  }),
  AsyncOnboardingApp = loadable({
    loader: () => import('./containers/OnboardingApp')
  }),
  AsyncAccountManagerApp = loadable({
    loader: () => import('./containers/AccountManagerApp')
  }),
  MultiLoginPage = loadable({
    loader: () => import('./containers/MultiLogin')
  }),
  ConnectShopify = loadable({
    loader: () => import('../revamp/src/components/ConnectShopify')
  }),
  PaymentStatus = loadable({
    loader: () => import('../revamp/src/components/PaymentStatus')
  }),
  BigCommerce = loadable({
    loader: () => import('../revamp/src/components/BigCommerce')
  }),
  NeedAssessment = loadable({
    loader: () => import('../revamp/src/components/NeedAssessment')
  }),
  HostedEsign = loadable({
    loader: () => import('../revamp/src/components/Hosted_Esign')
  });

const CreateHubApplication = loadable({
  loader: () => import('./containers/AppRegistration')
});

export default function () {
  return (
    <Router basename="/app">
      <Switch>
        <Redirect exact from="/" to="/dashboard" />
        <Route
          path="/account"
          component={AsyncAuthApp}
        />
        <PrivateRoute
          path="/dashboard"
          isAllowed={() => AuthManager.isLoggedIn()}
          redirectTo="/account"
          component={AsyncDashboardApp}
        />
        <PrivateRoute
          path="/onboarding"
          isAllowed={() => AuthManager.isLoggedIn()}
          redirectTo="/account"
          component={AsyncOnboardingApp}
        />
        <PrivateRoute
          path="/accountmanager"
          isAllowed={() => AuthManager.isLoggedIn()}
          redirectTo="/account"
          component={AsyncAccountManagerApp}
        />
        <PrivateRoute
          path="/manage_account"
          isAllowed={() => AuthManager.isLoggedIn()}
          redirectTo="/account"
          component={MultiLoginPage}
        />
        <PrivateRoute
          path="/client_credentials"
          isAllowed={() => AuthManager.isLoggedIn()}
          redirectTo="/account"
          component={CreateHubApplication}
        />
         <PrivateRoute
          path="/web/assessment"
          isAllowed={() => AuthManager.isLoggedIn()}
          redirectTo="/account"
          component={NeedAssessment}
        />
        <Route
          path="/web/shopify"
          component={ConnectShopify}
        />
        <Route
          path='/web/paymentStatus'
          component={PaymentStatus}
        />
        <Route
          path="/web/hosted_esign"
          component={HostedEsign}
        />
        <Route
          path="/web/bigCommerce/store"
          component={BigCommerce}
        />
        <Route path="/faqs" component={FaqsPage} />
        <Route path="/faq" component={FaqsPageHashLink} />
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  );
}
